import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getCvOfCampaignFailed,
  getCvOfCampaignStart,
  getCvOfCampaignSuccess,
} from "../redux/getCvofCampaign";
import { getCVOfCampaignApi } from "core/http/service/evaluation";

function* getListCandidateCampaignWork(
  action: ReturnType<typeof getCvOfCampaignStart>
) {
  const payload = action.payload;

  try {
    const res = yield call(getCVOfCampaignApi, payload);
    yield put({
      type: getCvOfCampaignSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getCvOfCampaignFailed.type,
    });
  }
}

function* watchGetCvOfCampaign() {
  yield takeLatest(getCvOfCampaignStart.type, getListCandidateCampaignWork);
}

export default function* getCvOfCampaignSaga() {
  yield all([watchGetCvOfCampaign()]);
}
